export const EMAIL_EXISTS_ERROR = 'Участник с таким e-mail уже существует';
export const PHONE_EXISTS_ERROR = 'Участник с таким телефоном уже существует';

export const EMAIL_EXISTS_PATTERN = /e-mail\s(уже\s)?существует/i;
export const PHONE_EXISTS_PATTERN = /номером телефона\s(уже\s)?существует/i;

export const processEmailError = (hasError: boolean, prevError: string): string => {
  if (hasError) {
    return EMAIL_EXISTS_ERROR;
  }
  if (prevError === EMAIL_EXISTS_ERROR) {
    return '';
  }
  return prevError;
};

export const processPhoneError = (hasError: boolean, prevError: string): string => {
  if (hasError) {
    return PHONE_EXISTS_ERROR;
  }
  return prevError;
};

export const processEmailChangeError = (validationError: string | false, prevError: string): string => {
  if (validationError) {
    return validationError;
  }

  if (prevError === EMAIL_EXISTS_ERROR) {
    return EMAIL_EXISTS_ERROR;
  }

  return '';
};
